import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Spacing } from '../../components/entities-card/Spacing';
import { PopoverWrapper } from '../../components/popovers/wrapper/PopoverWrapper';
import { EntitiesCardFooter } from '../../components/entities-card/EntitiesCardFooter';
import { EntitiesCardBody } from '../../components/entities-card/EntitiesCardBody';
import { EntitiesTitleLink } from '../../components/entities-card/EntitiesTitleLink';

type Props = {
  title: string;
  summary?: string;
  href?: string;
  target?: '_blank';
  handleClick: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
};

export const DecisionPopover: FC<Props> = ({
  title,
  summary,
  href,
  handleClick,
  target,
}) => {
  return (
    <PopoverWrapper>
      <EntitiesCardBody>
        <EntitiesTitleLink href={href} onClick={handleClick} target={target}>
          <span dangerouslySetInnerHTML={{ __html: title }} />
        </EntitiesTitleLink>
        <Spacing />
        {summary && (
          <p
            className="doctrine-popover__content"
            dangerouslySetInnerHTML={{ __html: summary }}
          />
        )}
      </EntitiesCardBody>
      <EntitiesCardFooter href={href} onClick={handleClick} target={target}>
        <FormattedMessage id="decision/popover/DecisionPopover.tsx/1" />
      </EntitiesCardFooter>
    </PopoverWrapper>
  );
};
